/**
 * @fileoverview Player de vídeo do chat. Baixa o arquivo via API autenticada e
 * reproduz de uma blob: URL same-origin — o MESMO caminho que RotatableImage já
 * usa para imagens. Evita o <video src> cross-origin cru, que renderiza os
 * controles mas não reproduz inline (o play vira "decoração"); só o download em
 * blob same-origin toca de forma confiável neste ambiente.
 */

import React, { useState, useEffect, useRef } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { CircularProgress } from "@material-ui/core";
import api from "../../services/api";

const useStyles = makeStyles(() => ({
  messageMedia: {
    objectFit: "cover",
    width: 250,
    height: 200,
    borderRadius: 8,
    display: "block",
  },
  placeholder: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "rgba(0, 0, 0, 0.06)",
  },
}));

const VideoPlayer = ({ videoUrl, className }) => {
  const classes = useStyles();
  const [blobUrl, setBlobUrl] = useState("");
  const [failed, setFailed] = useState(false);
  const blobRef = useRef("");

  useEffect(() => {
    if (!videoUrl) return undefined;
    let active = true;

    const fetchVideo = async () => {
      try {
        const { data, headers } = await api.get(videoUrl, {
          responseType: "blob",
        });
        if (!active) return;
        const url = window.URL.createObjectURL(
          new Blob([data], { type: headers["content-type"] || "video/mp4" })
        );
        blobRef.current = url;
        setBlobUrl(url);
      } catch (err) {
        if (active) setFailed(true);
      }
    };

    fetchVideo();

    return () => {
      active = false;
      if (blobRef.current) {
        window.URL.revokeObjectURL(blobRef.current);
        blobRef.current = "";
      }
    };
  }, [videoUrl]);

  const cls = className || classes.messageMedia;

  // Falha no download (raro): cai pro <video src> cru para ao menos manter o
  // comportamento atual (abrir o link direto ainda funciona).
  if (failed) {
    return <video className={cls} src={videoUrl} controls />;
  }

  if (!blobUrl) {
    return (
      <div className={`${cls} ${classes.placeholder}`}>
        <CircularProgress size={26} />
      </div>
    );
  }

  return <video className={cls} src={blobUrl} controls />;
};

export default VideoPlayer;
